/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { RefreshReservationPaymentPathParameters } from 'api/actions/refresh-reservation-payment/refresh-reservation-payment-path-parameters';
import { RefreshReservationPaymentResponse } from 'api/actions/refresh-reservation-payment/refresh-reservation-payment-response';

type RefreshReservationPaymentQueryParameters = Record<string, any>;

/**
 * The path of the RefreshReservationPayment action.
 */
export const refreshReservationPaymentActionPath = new SweetPath<keyof RefreshReservationPaymentPathParameters>(
  '/reservations/{reservationId}/payment/refresh',
  { path: '{param}' }
);

/**
 * Creates a contextualized RefreshReservationPayment actions.
 */
export default function createRefreshReservationPaymentAction(axios: AxiosInstance) {
  return function refreshReservationPaymentAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: RefreshReservationPaymentPathParameters;
    query?: RefreshReservationPaymentQueryParameters;
  }) {
    const path = refreshReservationPaymentActionPath.insert(parameters);

    return axios.post<RefreshReservationPaymentResponse, RefreshReservationPaymentResponse>(path, {
      params: query,
      headers,
    });
  };
}
